/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const Complexe = require('../types/Complexe')
// const CFonc = require('./CFonc')
const CCb = require('./CCb')
const CCbGlob = require('../kernel/CCbGlob')

module.exports = CAppelFonction

/**
 * Objet d'un arbre binaire de calcul représentant un appel de fonction réelle utilisateur.
 * @constructor
 * @extends CCb
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CCalculAncetre} fonctionAssociee : Peut pointer sur une fonction ou une suite.
 * @param {type} operande : L'opérande dont on cherche l'image.
 * @returns {CAppelFonction}
 */
function CAppelFonction (listeProprietaire, fonctionAssociee, operande) {
  if (arguments.length === 0) CCb.call(this) // Ajout version WebPack
  else {
    CCb.call(this, listeProprietaire);
    this.fonctionAssociee = fonctionAssociee;
    this.operande = operande;
    this.z1loc = new Complexe(); // Ajout version 4.9.7
  }
}
CAppelFonction.prototype = new CCb();
CAppelFonction.prototype.constructor = CAppelFonction;
CAppelFonction.prototype.superClass = "CCb";
CAppelFonction.prototype.className = "CAppelFonction";


CAppelFonction.prototype.nature = function() {
  return CCbGlob.natAppelFonction;
};

CAppelFonction.prototype.getClone = function(listeSource, listeCible) {
  var cloneOperande = this.operande.getClone(listeSource, listeCible);
  // à revoir car la fonction a déjà été créée
  var ind1 = listeSource.indexOf(this.fonctionAssociee);
  return new CAppelFonction(listeCible, listeCible.get(ind1, "CCalculAncetre"), cloneOperande);
};

CAppelFonction.prototype.resultatComplexe = function(infoRandom, zRes){
  this.operande.resultatComplexe(infoRandom, this.z1loc);
  this.fonctionAssociee.rendValeurFonctionComplexe(infoRandom, this.z1loc, zRes);
};

CAppelFonction.prototype.resultatFonctionComplexe = function(infoRandom, valeurParametre, zRes){
  this.operande.resultatFonctionComplexe(infoRandom, valeurParametre, this.z1loc);
  this.fonctionAssociee.rendValeurFonctionComplexe(infoRandom, this.z1loc, zRes);
};

CAppelFonction.prototype.existe = function(infoRandom) {
  return this.fonctionAssociee.existe && this.operande.existe(infoRandom);
};

CAppelFonction.prototype.resultat = function(infoRandom) {
  return this.fonctionAssociee.rendValeurFonction(infoRandom, this.operande.resultat(infoRandom));
};

CAppelFonction.prototype.resultatFonction = function(infoRandom, valeurParametre) {
  return this.fonctionAssociee.rendValeurFonction(infoRandom, this.operande.resultatFonction(infoRandom, valeurParametre));
};

CAppelFonction.prototype.initialisePourDependance = function() {
  CCb.prototype.initialisePourDependance.call(this);
  this.operande.initialisePourDependance();
};

CAppelFonction.prototype.dependDe = function(p) {
  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
  return this.memoriseDependance(CCb.prototype.dependDe.call(this,p) ||
    this.fonctionAssociee.dependDe(p) || this.operande.dependDe(p));
};

CAppelFonction.prototype.dependDePourBoucle = function(p) {
  return this.fonctionAssociee.dependDePourBoucle(p) || this.operande.dependDePourBoucle(p);
};

CAppelFonction.prototype.dependDeVariable = function(ind) {
  return this.operande.dependDeVariable(ind);
};

CAppelFonction.prototype.deriveePossible = function(indiceVariable) {
  var b = this.operande.deriveePossible(indiceVariable);
  if (this.fonctionAssociee.className === "CSuiteRec") return b;
  else return b || this.fonctionAssociee.deriveePossible(indiceVariable);
};

CAppelFonction.prototype.getCopie = function() {
  return new CAppelFonction(this.listeProprietaire, this.fonctionAssociee, this.operande.getCopie());
};

CAppelFonction.prototype.chaineCalcul = function(varFor) {
  // ElimineParenthesesDebut(cha);
  return this.fonctionAssociee.getNom() + "(" + this.operande.chaineCalculSansPar(varFor) + ")";
};

CAppelFonction.prototype.chaineLatex = function(varFor) {
  var parouvLatex = "\\left(";
  var parferLatex = "\\right)";
  // ElimineParenthesesDebut(cha);
  return this.fonctionAssociee.getNom() + parouvLatex + this.operande.chaineLatexSansPar(varFor) + parferLatex;
};

CAppelFonction.prototype.read = function(inps, list){
  CCb.prototype.read.call(this, inps, list);
  var ind1 = inps.readInt();
  this.fonctionAssociee = list.get(ind1,"CCalculAncetre");
  this.operande = inps.readObject(list);
};

CAppelFonction.prototype.write = function(oups, list){
  CCb.prototype.write.call(this, oups, list);
  var ind1 = list.indexOf(this.fonctionAssociee);
  oups.writeInt(ind1);
  oups.writeObject(this.operande);
};

CAppelFonction.prototype.estConstant = function() {
  return this.fonctionAssociee.estConstant() && this.operande.estConstant();
};

CAppelFonction.prototype.calculAvecValeursRemplacees = function() {
  const CFonc = require('./CFonc')
  var fon = (this.fonctionAssociee.className === "CFonc") ? new CFonc(this.listeProprietaire, null, false, this.fonctionAssociee.nomCalcul,"",
  			this.fonctionAssociee.chaineVariable, this.fonctionAssociee.calcul.calculAvecValeursRemplacees()) : this.fonctionAssociee;
  return new CAppelFonction(this.listeProprietaire, fon, this.operande.calculAvecValeursRemplacees());
};

CAppelFonction.prototype.membreGauche = function() {
  return this.fonctionAssociee.membreGauche();
};

CAppelFonction.prototype.membreDroit = function() {
  return this.fonctionAssociee.membreDroit();
};



// WEBPACK FOOTER //
// ./src/objets/CAppelFonction.js